
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';

//functionality
import fetcher from '../../services/axios.service';

//assets
import ChatbotIcon from '../../assets/img/ChatIcon.svg'

const greetFun = () => {
    var today = new Date()
    var curHr = today.getHours()

    if (curHr < 12) {
        return ('good morning')
    } else if (curHr < 18) {
        return ('good afternoon')
    } else {
        return ('good evening')
    }
}

let steps = [
    {
        id: '1',
        message: `Hello, ${greetFun()} !`,
        trigger: '2',
    },
    {
        id: '2',
        user: true,
        trigger: 'name',
    },
    {
        id: 'name',
        message: 'Please enter your name.',
        trigger: '3',
    },
    {
        id: '3',
        user: true,
        trigger: 'greet',
    },
    {
        id: 'greet',
        message: 'Hi {previousValue}, nice to meet you!, please provide your email & phone no.',
        trigger: '5',
    },
    {
        id: '5',
        user: true,
        trigger: 'query',
    },
    {
        id: 'query',
        message: 'What query do you have?',
        trigger: '7',
    },
    {
        id: '7',
        user: true,
        trigger: '8',
    },
    {
        id: '8',
        message: 'Thank you 🤗, we will email you shortly.',
        end: true,
    },
]

const theme = {
    background: '#f5f8fb',
    headerBgColor: '#C99019',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#C99019',
    botFontColor: '#fff',
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
};


const submitData = async (data) => {
    let name = data.values[1], emailPhone = data.values[2], query = data.values[3];
    try {
        console.log(name, emailPhone, query);
        await fetcher.post('/v1/chatbot/create', { name, emailPhone, query });
    } catch (error) {
        alert(error)
    }
}
const ChatbotCustom = () => {
    return (
        <ThemeProvider theme={theme}>
            <ChatBot
                floatingIcon={ChatbotIcon}
                floating={true}
                handleEnd={d => submitData(d)}
                headerTitle="Global Fx Chatbot"
                userDelay={0}
                // botAvatar="https://engineering.unl.edu/images/staff/Kayla-Person.jpg"
                steps={steps}
            />
        </ThemeProvider>
    )
}

export default ChatbotCustom